define('gigaset_recurring/classes/checkout/sidebar',[
	"jquery",
	"lodash",
	"cartware/jquery/bem",
	"lucid"
], function(
	$,
	_,
	BEM,
	lucidJS
) {
	function Step(titleTmpl, infoTmpl, title, info) {
		lucidJS.EventEmitter.call(this);
		this.title = title;
		this.info = info;

		this.titleTmpl = titleTmpl;
		this.infoTmpl = infoTmpl;

		this.titleNode = $(this.titleTmpl(this)).filter("*");
		this.infoNode = $(this.infoTmpl(this)).filter("*");

		this.titleNode.on("click", _.bind(function() {
			this.emit("click");
		}, this));
	}

	Step.prototype = _.create(new lucidJS.EventEmitter, {
		title:		null,
		titleTmpl:	null,
		info:		null,
		infoTmpl:	null,
		domNode:	null,

		getTitle: function() {
			return this.title;
		},

		setTitle: function(title) {
			this.title = title;

			var titleNode = $(this.titleTmpl(this)).filter("*");
			this.titleNode.replaceWith(titleNode);
			this.titleNode = titleNode

			return this;
		},

		getContent: function() {
			return this.info;
		},

		setContent: function(content) {
			this.info = content;

			var infoNode = $(this.infoTmpl(this)).filter("*");
			this.infoNode.replaceWith(infoNode);
			this.infoNode = infoNode

			return this;
		},

		setComplete: function(flag) {
			flag = "undefined" === typeof flag ? true : !!flag;
			this.titleNode[flag ? "bemAddModifier" : "bemRemoveModifier"]("complete");
			this.infoNode[flag ? "bemAddModifier" : "bemRemoveModifier"]("complete");
		},

		setActive: function(flag) {
			flag = "undefined" === typeof flag ? true : !!flag;
			this.titleNode[flag ? "bemAddModifier" : "bemRemoveModifier"]("current");
			this.infoNode[flag ? "bemAddModifier" : "bemRemoveModifier"]("current");
		}
	});

	function Sidebar (sidebarBlock, block) {
		this.sidebarBlock = BEM.block(sidebarBlock);
		this.block = BEM.block(block);
		this.list = this.block.getElements("list");
		this.titleTmpl = _.template(this.block.getElements("sidebar-step-title").html());
		this.infoTmpl = _.template(this.block.getElements("sidebar-step-info").html());
		this.steps = [];
	}

	Sidebar.prototype = {
		block:		null,
		list:		null,
		stepTmpl:	null,
		steps:		null,

		addStep: function(step) {
			var sidebarStep = new Step(this.titleTmpl, this.infoTmpl, step.getTitle(), step.getProgressContent());

			step.on("close", function() {
				sidebarStep.setContent(step.getProgressContent());
				sidebarStep.titleNode.after(sidebarStep.infoNode);
			});

			this.steps.push(sidebarStep);
			this.list.append(sidebarStep.titleNode);

			return sidebarStep;
		},

		show: function() {
			this.sidebarBlock.bemRemoveModifier("hidden");
		},

		hide: function() {
			this.sidebarBlock.bemAddModifier("hidden");
		}
	}

	return Sidebar;
});
